import emitter from '@utils/emitter'

export default {
  name: 'audio-button',

  events: [
    {
      on: 'click',
      handle () {
        this.isPlaying = !this.isPlaying

        this.el.classList.toggle('is-open')

        if (this.isPlaying) {
          clearTimeout(this.hideTimeout)
          this.el.classList.remove('is-hidden')

          emitter.trigger('AUDIO_ON')
        } else {
          emitter.trigger('AUDIO_OFF')
        }
      },
    },
  ],

  componentDidMount () {
    this.isPlaying = true

    document.addEventListener('mousemove', this.handleMouseMove)
  },

  componentWillUnmount () {
    document.removeEventListener('mousemove', this.handleMouseMove)
  },

  handleMouseMove (e) {
    clearTimeout(this.hideTimeout)
    this.el.classList.remove('is-hidden')

    this.hideTimeout = setTimeout(() => {
      this.el.classList.add('is-hidden')
    }, 2000)
  },
}
